//login
export const SIGN_IN = "SIGN_IN";
export const GET_PROFILE = "GET_PROFILE";

//PLACE
export const GET_ALL_PLACE = "GET_ALL_PLACE";
export const GET_ALL_TRANSACTION_PLACE = "GET_ALL_TRANSACTION_PLACE";
export const SET_PLACE = "SET_PLACE";
export const UPDATE_PLACE = "UPDATE_PLACE";
export const DELETE_PLACE = "DELETE_PLACE";
export const DELETE_MULTIPLE_PLACE = "DELETE_MULTIPLE_PLACE";
export const GET_ONE_PLACE = "GET_ONE_PLACE";
export const CLEAR_ONE_PLACE = "CLEAR_ONE_PLACE";
export const GET_ALL_PLACE_IMAGE = "GET_ALL_PLACE_IMAGE";
export const SET_PLACE_IMAGE = "SET_PLACE_IMAGE";
export const DELETE_PLACE_IMAGE = "DELETE_PLACE_IMAGE";
export const GET_ALL_PLACE_VIDEO = "GET_ALL_PLACE_VIDEO";
export const SET_PLACE_VIDEO = "SET_PLACE_VIDEO";
export const DELETE_PLACE_VIDEO = "DELETE_PLACE_VIDEO";
export const GET_ALL_PLACE_REELS = "GET_ALL_PLACE_REELS";
export const SET_PLACE_REELS = "SET_PLACE_REELS";
export const DELETE_PLACE_REELS = "DELETE_PLACE_REELS";
export const GET_ALL_PLACE_ON_SETTING = "GET_ALL_PLACE_ON_SETTING";
export const SET_ALL_PLACE_ON_SETTING = "SET_ALL_PLACE_ON_SETTING";
export const DELETE_PLACE_ON_SETTING = "DELETE_PLACE_ON_SETTING";
export const GET_ALL_PLACE_OFF_SETTING = "GET_ALL_PLACE_OFF_SETTING";
export const SET_ALL_PLACE_OFF_SETTING = "SET_ALL_PLACE_OFF_SETTING";
export const DELETE_PLACE_OFF_SETTING = "DELETE_PLACE_OFF_SETTING";
export const GET_ALL_PLACE_BOOKING_ON_SETTING =
  "GET_ALL_PLACE_BOOKING_ON_SETTING";
export const SET_ALL_PLACE_BOOKING_ON_SETTING =
  "SET_ALL_PLACE_BOOKING_ON_SETTING";
export const DELETE_PLACE_BOOKING_ON_SETTING =
  "DELETE_PLACE_BOOKING_ON_SETTING";
export const GET_ALL_PACKAGE_CATEGORY = "GET_ALL_PACKAGE_CATEGORY";
export const GET_ONE_PACKAGE_CATEGORY = "GET_ONE_PACKAGE_CATEGORY";
export const CLEAR_PACKAGE_CATEGORY = "CLEAR_PACKAGE_CATEGORY";
export const SET_PACKAGE_CATEGORY = "SET_PACKAGE_CATEGORY";
export const UPDATE_PACKAGE_CATEGORY = "UPDATE_PACKAGE_CATEGORY";
export const DELETE_PACKAGE_CATEGORY = "DELETE_PACKAGE_CATEGORY";
export const GET_ALL_PACKAGE = "GET_ALL_PACKAGE";
export const GET_ONE_PACKAGE = "GET_ONE_PACKAGE";
export const CLEAR_ONE_PACKAGE = "CLEAR_ONE_PACKAGE";
export const SET_PACKAGE = "SET_PACKAGE";
export const UPDATE_PACKAGE = "UPDATE_PACKAGE";
export const DELETE_PACKAGE = "DELETE_PACKAGE";
export const GET_ALL_BOOKINGS = "GET_ALL_BOOKINGS";
export const GET_ONE_BOOKING = "GET_ONE_BOOKING";
export const GET_BOOKING_PAYMENT = "GET_BOOKING_PAYMENT";
export const CLEAR_ONE_BOOKING = "CLEAR_ONE_BOOKING";
export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const MOVE_BOOKING = "MOVE_BOOKING";
export const GET_ATTRACTION_BOOKING_COUNT = "GET_ATTRACTION_BOOKING_COUNT";
export const GET_ALL_TEAM = "GET_ALL_TEAM";
export const SET_TEAM = "SET_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
export const GET_ONE_TEAM = "GET_ONE_TEAM";
export const CLEAR_ONE_TEAM = "CLEAR_ONE_TEAM";
export const GET_TEAM_ATTENDANCE = "GET_TEAM_ATTENDANCE";
export const SET_TEAM_ATTENDANCE = "SET_TEAM_ATTENDANCE";
export const UPDATE_TEAM_ATTENDANCE = "UPDATE_TEAM_ATTENDANCE";
export const GET_ONE_TEAM_ATTENDANCE = "GET_ONE_TEAM_ATTENDANCE";
export const CLEAR_ONE_TEAM_ATTENDANCE = "CLEAR_ONE_TEAM_ATTENDANCE";
export const GET_ALL_BANK_ACCOUNT = "GET_ALL_BANK_ACCOUNT";
export const SET_BANK_ACCOUNT = "SET_BANK_ACCOUNT";
export const UPDATE_BANK_ACCOUNT = "UPDATE_BANK_ACCOUNT";
export const DELETE_BANK_ACCOUNT = "DELETE_BANK_ACCOUNT";
export const GET_ONE_BANK_ACCOUNT = "GET_ONE_BANK_ACCOUNT";
export const CLEAR_ONE_BANK_ACCOUNT = "CLEAR_ONE_BANK_ACCOUNT";
export const GET_ALL_CREDIT_CARD = "GET_ALL_CREDIT_CARD";
export const SET_CREDIT_CARD = "SET_CREDIT_CARD";
export const UPDATE_CREDIT_CARD = "UPDATE_CREDIT_CARD";
export const DELETE_CREDIT_CARD = "DELETE_CREDIT_CARD";
export const GET_ONE_CREDIT_CARD = "GET_ONE_CREDIT_CARD";
export const CLEAR_ONE_CREDIT_CARD = "CLEAR_ONE_CREDIT_CARD";
export const GET_ALL_DEBIT_CATEGORY = "GET_ALL_DEBIT_CATEGORY";
export const GET_ONE_DEBIT_CATEGORY = "GET_ONE_DEBIT_CATEGORY";
export const SET_DEBIT_CATEGORY = "SET_DEBIT_CATEGORY";
export const UPDATE_DEBIT_CATEGORY = "UPDATE_DEBIT_CATEGORY";
export const DELETE_DEBIT_CATEGORY = "DELETE_DEBIT_CATEGORY";
export const CLEAR_ONE_DEBIT_CATEGORY = "CLEAR_ONE_DEBIT_CATEGORY";
export const GET_ALL_CREDIT_CATEGORY = "GET_ALL_CREDIT_CATEGORY";
export const GET_ONE_CREDIT_CATEGORY = "GET_ONE_CREDIT_CATEGORY";
export const SET_CREDIT_CATEGORY = "SET_CREDIT_CATEGORY";
export const UPDATE_CREDIT_CATEGORY = "UPDATE_CREDIT_CATEGORY";
export const DELETE_CREDIT_CATEGORY = "DELETE_CREDIT_CATEGORY";
export const CLEAR_ONE_CREDIT_CATEGORY = "CLEAR_ONE_CREDIT_CATEGORY";
export const GET_CURRENT_BALANCE_TOTAL = "GET_CURRENT_BALANCE_TOTAL";
export const GET_ALL_PACKAGE_BOOKINGS = "GET_ALL_PACKAGE_BOOKINGS";
export const GET_PACKAGE_BOOKING_COUNT = "GET_PACKAGE_BOOKING_COUNT";
export const GET_ALL_DEBIT_NOTE = "GET_ALL_DEBIT_NOTE";
export const SET_DEBIT_NOTE = "SET_DEBIT_NOTE";
export const UPDATE_DEBIT_NOTE = "UPDATE_DEBIT_NOTE";
export const DELETE_DEBIT_NOTE = "DELETE_DEBIT_NOTE";
export const GET_ONE_DEBIT_NOTE = "GET_ONE_DEBIT_NOTE";
export const CLEAR_ONE_DEBIT_NOTE = "CLEAR_ONE_DEBIT_NOTE";
export const GET_ALL_CREDIT_NOTE = "GET_ALL_CREDIT_NOTE";
export const SET_CREDIT_NOTE = "SET_CREDIT_NOTE";
export const UPDATE_CREDIT_NOTE = "UPDATE_CREDIT_NOTE";
export const DELETE_CREDIT_NOTE = "DELETE_CREDIT_NOTE";
export const GET_ONE_CREDIT_NOTE = "GET_ONE_CREDIT_NOTE";
export const CLEAR_ONE_CREDIT_NOTE = "CLEAR_ONE_CREDIT_NOTE";

export const GET_ALL_SALES = "GET_ALL_SALES";
export const GET_ALL_PURCHASE = "GET_ALL_PURCHASE";

export const GET_CR_DR_TOTAL = "GET_CR_DR_TOTAL";
export const GET_ONE_SITE_SETTING = "GET_ONE_SITE_SETTING";
export const GET_ONE_HOTEL_SETTING = "GET_ONE_HOTEL_SETTING";
export const GET_ALL_HOME_BANNER = "GET_ALL_HOME_BANNER";
export const SET_HOME_BANNER = "SET_HOME_BANNER";
export const UPDATE_HOME_BANNER = "UPDATE_HOME_BANNER";
export const DELETE_HOME_BANNER = "DELETE_HOME_BANNER";
export const GET_ONE_HOME_BANNER = "GET_ONE_HOME_BANNER";
export const CLEAR_ONE_HOME_BANNER = "CLEAR_ONE_HOME_BANNER";

export const GET_ALL_HOME_PLACE = "GET_ALL_HOME_PLACE";
export const SET_HOME_PLACE = "SET_HOME_PLACE";
export const UPDATE_HOME_PLACE = "UPDATE_HOME_PLACE";
export const DELETE_HOME_PLACE = "DELETE_HOME_PLACE";
export const GET_ONE_HOME_PLACE = "GET_ONE_HOME_PLACE";
export const CLEAR_ONE_HOME_PLACE = "CLEAR_ONE_HOME_PLACE";

export const GET_ALL_SOU_NUMBER = "GET_ALL_SOU_NUMBER";
export const SET_SOU_NUMBER = "SET_SOU_NUMBER";
export const UPDATE_SOU_NUMBER = "UPDATE_SOU_NUMBER";
export const DELETE_SOU_NUMBER = "DELETE_SOU_NUMBER";
export const GET_ONE_SOU_NUMBER = "GET_ONE_SOU_NUMBER";
export const CLEAR_ONE_SOU_NUMBER = "CLEAR_ONE_SOU_NUMBER";

export const GET_ALL_BANK_ACCESS = "GET_ALL_BANK_ACCESS";
export const SET_BANK_ACCESS = "SET_BANK_ACCESS";
export const UPDATE_BANK_ACCESS = "UPDATE_BANK_ACCESS";

export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_DASHBOARD_OTHER_DATA = "GET_DASHBOARD_OTHER_DATA";

export const GET_ACCESS_KEYS = "GET_ACCESS_KEYS";

export const GET_ALL_BANK_TRANSFER = "GET_ALL_BANK_TRANSFER";
export const SET_BANK_TRANSFER = "SET_BANK_TRANSFER";

export const GET_ALL_NUMBER_ACCESS = "GET_ALL_NUMBER_ACCESS";
export const SET_NUMBER_ACCESS = "SET_NUMBER_ACCESS";
export const UPDATE_NUMBER_ACCESS = "UPDATE_NUMBER_ACCESS";

export const GET_ALL_QUOTATION = "GET_ALL_QUOTATION";
export const SET_QUOTATION = "SET_QUOTATION";
export const UPDATE_QUOTATION = "UPDATE_QUOTATION";
export const DELETE_QUOTATION = "DELETE_QUOTATION";
export const GET_ONE_QUOTATION = "GET_ONE_QUOTATION";
export const CLEAR_ONE_QUOTATION = "CLEAR_ONE_QUOTATION";

export const GET_ALL_VISITOR = "GET_ALL_VISITOR";
export const SET_ALL_VISITOR = "SET_ALL_VISITOR";
export const UPDATE_VISITOR = "UPDATE_VISITOR";
export const DELETE_VISITOR = "DELETE_VISITOR";

export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";
export const GET_ALL_STATES = "GET_ALL_STATES";
export const GET_TEAM_BANK_REPORT = "GET_TEAM_BANK_REPORT";
export const GET_TEAM_SALES_REPORT = "GET_TEAM_SALES_REPORT";
export const GET_TEAM_SALES_DATA = "GET_TEAM_SALES_DATA";
export const GET_TEAM_BANK_REPORT_DATA = "GET_TEAM_BANK_REPORT_DATA";

export const GET_ALL_ENQUIRY = "GET_ALL_ENQUIRY";
export const SET_ENQUIRY = "SET_ENQUIRY";
export const UPDATE_ENQUIRY = "UPDATE_ENQUIRY";
export const DELETE_ENQUIRY = "DELETE_ENQUIRY";
export const GET_ONE_ENQUIRY = "GET_ONE_ENQUIRY";
export const CLEAR_ONE_ENQUIRY = "CLEAR_ONE_ENQUIRY";

export const GET_ALL_PACKAGE_IMAGE = "GET_ALL_PACKAGE_IMAGE";
export const SET_PACKAGE_IMAGE = "SET_PACKAGE_IMAGE";
export const DELETE_PACKAGE_IMAGE = "DELETE_PACKAGE_IMAGE";
export const GET_ALL_PACKAGE_VIDEO = "GET_ALL_PACKAGE_VIDEO";
export const SET_PACKAGE_VIDEO = "SET_PACKAGE_VIDEO";
export const DELETE_PACKAGE_VIDEO = "DELETE_PACKAGE_VIDEO";
export const GET_ALL_PACKAGE_REELS = "GET_ALL_PACKAGE_REELS";
export const SET_PACKAGE_REELS = "SET_PACKAGE_REELS";
export const DELETE_PACKAGE_REELS = "DELETE_PACKAGE_REELS";

export const GET_TEAM_SEALERY_REPORT = "GET_TEAM_SEALERY_REPORT";

export const GET_PLACE_BOOKING_OFF_SETTING = "GET_PLACE_BOOKING_OFF_SETTING";
export const SET_PLACE_BOOKING_OFF_SETTING =
  "SET_ALL_PLACE_BOOKING_OFF_SETTING";
export const DELETE_PLACE_BOOKING_OFF_SETTING =
  "DELETE_PLACE_BOOKING_OFF_SETTING";

export const GET_PAYMENT_HISTORY = "GET_PAYMENT_HISTORY";

export const GET_DAILY_LEDGER = "GET_DAILY_LEDGER";

export const GET_ONE_HOME_NOTE = "GET_ONE_HOME_NOTE";

export const GET_ALL_SOU_PLACE_KEY = "GET_ALL_SOU_PLACE_KEY";

export const GET_ALL_FAQ = "GET_ALL_FAQ";
export const SET_FAQ = "SET_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";
export const GET_ONE_FAQ = "GET_ONE_FAQ";
export const CLEAR_ONE_FAQ = "CLEAR_ONE_FAQ";

export const GET_WARNING_MESSAGE = "GET_WARNING_MESSAGE";

export const GET_AVAILABLE_TICKETS = "GET_AVAILABLE_TICKETS";
export const UPDATE_AVAILABLE_TICKETS = "UPDATE_AVAILABLE_TICKETS";

export const GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";

export const GET_ALL_HOTEL = "GET_ALL_HOTEL";

export const GET_ALL_TESTIMONIAL = "GET_ALL_TESTIMONIAL";
export const SET_TESTIMONIAL = "SET_TESTIMONIAL";
export const UPDATE_TESTIMONIAL = "UPDATE_TESTIMONIAL";
export const DELETE_TESTIMONIAL = "DELETE_TESTIMONIAL";
export const GET_ONE_TESTIMONIAL = "GET_ONE_TESTIMONIAL";
export const CLEAR_ONE_TESTIMONIAL = "CLEAR_ONE_TESTIMONIAL";

export const GET_SALES_REPORT = "GET_SALES_REPORT";
export const GET_SALES_REPORT_EXPORT = "GET_SALES_REPORT_EXPORT";
export const GET_SALES_REPORT_TOTAL = "GET_SALES_REPORT_TOTAL";

export const GET_PURCHASE_REPORT = "GET_PURCHASE_REPORT";
export const GET_PURCHASE_REPORT_EXPORT = "GET_PURCHASE_REPORT_EXPORT";
export const GET_PURCHASE_REPORT_TOTAL = "GET_PURCHASE_REPORT_TOTAL";

export const GET_COMMISSION_REPORT = "GET_COMMISSION_REPORT";
export const GET_COMMISSION_REPORT_EXPORT = "GET_COMMISSION_REPORT_EXPORT";
export const GET_COMMISSION_REPORT_TOTAL = "GET_COMMISSION_REPORT_TOTAL";

export const GET_CANCEL_REPORT = "GET_CANCEL_REPORT";
export const GET_CANCEL_REPORT_EXPORT = "GET_CANCEL_REPORT_EXPORT";
export const GET_CANCEL_REPORT_TOTAL = "GET_CANCEL_REPORT_TOTAL";

export const GET_ATTRACTION_REPORT = "GET_ATTRACTION_REPORT";
export const GET_ATTRACTION_REPORT_EXPORT = "GET_ATTRACTION_REPORT_EXPORT";
export const GET_ATTRACTION_REPORT_TOTAL = "GET_ATTRACTION_REPORT_TOTAL";

export const GET_GST_REPORT = "GET_GST_REPORT";
export const GET_GST_REPORT_EXPORT = "GET_GST_REPORT_EXPORT";
export const GET_GST_REPORT_TOTAL = "GET_GST_REPORT_TOTAL";

export const GET_BOOKING_FOR_REVIEW = "GET_BOOKING_FOR_REVIEW";

// BLOG CATEGORY
export const GET_ALL_BLOG_CATEGORY = "GET_ALL_BLOG_CATEGORY";
export const GET_ONE_BLOG_CATEGORY = "GET_ONE_BLOG_CATEGORY";
export const CLEAR_ONE_BLOG_CATEGORY = "CLEAR_ONE_BLOG_CATEGORY";
export const SET_BLOG_CATEGORY = "SET_BLOG_CATEGORY";
export const UPDATE_BLOG_CATEGORY = "UPDATE_BLOG_CATEGORY";
export const DELETE_BLOG_CATEGORY = "DELETE_BLOG_CATEGORY";

// BLOG
export const GET_ALL_BLOG = "GET_ALL_BLOG";
export const GET_ONE_BLOG = "GET_ONE_BLOG";
export const CLEAR_ONE_BLOG = "CLEAR_ONE_BLOG";
export const SET_BLOG = "SET_BLOG";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const DELETE_BLOG = "DELETE_BLOG";

// BLOG COMMENT
export const GET_ALL_BLOG_COMMENT = "GET_ALL_BLOG_COMMENT";
export const SET_BLOG_COMMENT = "SET_BLOG_COMMENT";
export const UPDATE_BLOG_COMMENT = "UPDATE_BLOG_COMMENT";
export const DELETE_BLOG_COMMENT = "DELETE_BLOG_COMMENT";

// PENDING RAZORPAY SETTLEMENT
export const GET_PENDING_RAZORPAY_SETTLEMENT = "GET_PENDING_RAZORPAY_SETTLEMENT";

// DAILY SETTLEMENTS
export const GET_ALL_DAILY_SETTLEMENTS = "GET_ALL_DAILY_SETTLEMENTS";
export const GET_ONE_DAILY_SETTLEMENT = "GET_ONE_DAILY_SETTLEMENT";
export const CLEAR_ONE_DAILY_SETTLEMENT = "CLEAR_ONE_DAILY_SETTLEMENT";

// TALLY
export const GET_ALL_TALLY_MAIN_GROUP = "GET_ALL_TALLY_MAIN_GROUP";
export const SET_TALLY_MAIN_GROUP = "SET_TALLY_MAIN_GROUP";
export const UPDATE_TALLY_MAIN_GROUP = "UPDATE_TALLY_MAIN_GROUP";
export const DELETE_TALLY_MAIN_GROUP = "DELETE_TALLY_MAIN_GROUP";
export const UPDATE_TALLY_MAIN_GROUP_STATUS = "UPDATE_TALLY_MAIN_GROUP_STATUS";

export const GET_ALL_TALLY_SUB_GROUP = "GET_ALL_TALLY_SUB_GROUP";
export const SET_TALLY_SUB_GROUP = "SET_TALLY_SUB_GROUP";
export const UPDATE_TALLY_SUB_GROUP = "UPDATE_TALLY_SUB_GROUP";
export const DELETE_TALLY_SUB_GROUP = "DELETE_TALLY_SUB_GROUP";
export const UPDATE_TALLY_SUB_GROUP_STATUS = "UPDATE_TALLY_SUB_GROUP_STATUS";

export const GET_ALL_TALLY_LEDGER = "GET_ALL_TALLY_LEDGER";
export const SET_TALLY_LEDGER = "SET_TALLY_LEDGER";
export const UPDATE_TALLY_LEDGER = "UPDATE_TALLY_LEDGER";
export const DELETE_TALLY_LEDGER = "DELETE_TALLY_LEDGER";
export const UPDATE_TALLY_LEDGER_STATUS = "UPDATE_TALLY_LEDGER_STATUS";

export const GET_TALLY_BALANCE_SHEET = "GET_TALLY_BALANCE_SHEET";
export const GET_TALLY_PROFIT_LOSS = "GET_TALLY_PROFIT_LOSS";

export const GET_AUTO_ACCOUNT_ENTRY_SETTING = "GET_AUTO_ACCOUNT_ENTRY_SETTING";
export const UPDATE_AUTO_ACCOUNT_ENTRY_SETTING = "UPDATE_AUTO_ACCOUNT_ENTRY_SETTING";

// OPTIONAL ATTRACTION
export const GET_ALL_OPTIONAL_ATTRACTION = "GET_ALL_OPTIONAL_ATTRACTION";
export const SET_OPTIONAL_ATTRACTION = "SET_OPTIONAL_ATTRACTION";
export const UPDATE_OPTIONAL_ATTRACTION = "UPDATE_OPTIONAL_ATTRACTION";
export const DELETE_OPTIONAL_ATTRACTION = "DELETE_OPTIONAL_ATTRACTION";export const GET_ONE_OPTIONAL_ATTRACTION = "GET_ONE_OPTIONAL_ATTRACTION";
export const CLEAR_ONE_OPTIONAL_ATTRACTION = "CLEAR_ONE_OPTIONAL_ATTRACTION";

// SITEMAP
export const GET_ALL_SITEMAP = "GET_ALL_SITEMAP";
export const SET_SITEMAP = "SET_SITEMAP";
export const UPDATE_SITEMAP = "UPDATE_SITEMAP";
export const DELETE_SITEMAP = "DELETE_SITEMAP";
export const GET_ONE_SITEMAP = "GET_ONE_SITEMAP";
export const CLEAR_ONE_SITEMAP = "CLEAR_ONE_SITEMAP";
